import React, { useRef, useCallback, useEffect, useState } from "react";

/**
 * 防抖hook
 * @param {*} fn
 * @param {*} delay
 * @param {*} dep
 */
export function useDebounce(fn, delay, dep = []) {
  const { current } = useRef({ fn, timer: null });
  useEffect(
    function () {
      current.fn = fn;
    },
    [fn]
  );

  return useCallback(function f(...args) {
    if (current.timer) {
      clearTimeout(current.timer);
    }
    current.timer = setTimeout(() => {
      current.fn.call(this, ...args);
    }, delay);
  }, dep);
}

/**
 * 节流hook
 * @param {*} fn
 * @param {*} delay
 * @param {*} dep
 */
export function useThrottle(fn, delay, dep = []) {
  const { current } = useRef({ fn, timer: null });
  useEffect(
    function () {
      current.fn = fn;
    },
    [fn]
  );

  return useCallback(function f(...args) {
    if (!current.timer) {
      current.timer = setTimeout(() => {
        delete current.timer;
      }, delay);
      current.fn.call(this, ...args);
    }
  }, dep);
}

/**
 * 自定义websocket
 * @param url
 * @returns {{reconnect: reconnect, readyState: {value: string, key: number}, sendMessage: sendMessage, closeWebSocket: closeWebSocket, messageData: undefined}}
 */
export function useWebsocket({ url }) {
  const ws = useRef(null);
  const [readyState, setReadyState] = useState({ key: 0, value: '正在连接中' })
  const [messageData, setMessageData] = useState(undefined)

  const webSocketInit = () => {
    if (!ws.current || ws.current.readyState === 3) {
      createWebSocket()
    }
  };
  /**
   * 创建
   */
  const createWebSocket = () => {
    try {
      const readyStateArr = [
        { key: 0, value: '正在连接中' },
        { key: 1, value: '已经连接并且可以通讯' },
        { key: 2, value: '连接正在关闭' },
        { key: 3, value: '连接已关闭或者没有连接成功' }
      ]

      ws.current = new WebSocket(url)

      ws.current.onopen = (evt) => {
        setReadyState(readyStateArr[ws.current?.readyState ?? 0])
      }
      ws.current.onclose = (evt) => setReadyState(readyStateArr[ws.current?.readyState ?? 0])
      ws.current.onmessage = (evt) => {
        setMessageData(evt.data)
      }
      ws.current.onerror = (evt) => setReadyState(readyStateArr[ws.current?.readyState ?? 0])

    } catch (error) {
      console.log(error)
    }
  }

  /**
   * 关闭
   */
  const closeWebSocket = () => {
    ws.current?.close()
  }

  /**
   * 重连
   */
  const reconnect = () => {
    try {
      closeWebSocket()
      ws.current = null
      createWebSocket()
    } catch (e) {
      console.log(e)
    }
  }

  const sendMessage = (msg) => {
    console.log('sendMsg>>>>>>>>>readyState',msg,ws.current.readyState)
    if (!ws.current || ws.current.readyState !== 1) {
      return;
    }
    console.log('sendMsg',msg)
    console.log(ws.current.send)
    ws.current.send(msg)
  }

  useEffect(() => {
    webSocketInit()
    return () => {
      ws.current?.close()
    }
  }, [ws])


  return {
    readyState,
    closeWebSocket,
    reconnect,
    sendMessage,
    messageData
  }
}


